const scrollToSection = (id: string) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export default function BusinessIntro() {
  return (
    <section className="py-24 bg-[#faf8f4]">
      <div className="max-w-6xl mx-auto px-8">
        <div className="text-center mb-16">
          <p className="text-[#1e3a70] text-sm font-medium tracking-widest uppercase mb-3">OUR SERVICES</p>
          <h2 className="text-3xl font-bold text-stone-800 mb-4">2つの専門事業で、理想の暮らしへ</h2>
          <p className="text-stone-500 text-base max-w-xl mx-auto leading-relaxed">
            「建てる」と「暮らす」。住まいのすべてのフェーズを、専門的な知識と経験でサポートします。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* 建てサポ */}
          <div className="group bg-white rounded-2xl overflow-hidden hover:translate-y-[-4px] transition-all duration-300 border border-stone-100">
            <div className="relative overflow-hidden" style={{ height: '240px' }}>
              <img
                src="https://public.readdy.ai/ai/img_res/cdd94e5289e02851368887e756d4eed8.jpg"
                alt="建てサポ事業"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-[#1e3a70] text-white text-xs font-medium px-3 py-1.5 rounded-full">
                  建てサポ事業
                </span>
              </div>
            </div>
            <div className="p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#eef3fb] rounded-full flex items-center justify-center">
                  <i className="ri-building-2-line text-[#1e3a70] text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-stone-800">賃貸併用住宅<br />建築コンサルティング</h3>
              </div>
              <p className="text-stone-500 text-sm leading-relaxed mb-6">
                賃貸併用住宅の建築計画から入居者募集まで、ハウスメーカー・工務店の垣根を越えた中立的な立場でサポート。収益性と居住性を両立する住まいの実現をお手伝いします。
              </p>
              <div className="flex flex-wrap gap-2 mb-6">
                {['建築計画', 'ハウスメーカー比較', '資金計画', '収益シミュレーション'].map((tag) => (
                  <span key={tag} className="text-xs bg-[#eef3fb] text-[#1e3a70] border border-[#b8cce8] px-3 py-1 rounded-full">
                    {tag}
                  </span>
                ))}
              </div>
              <button
                onClick={() => scrollToSection('tatesapo')}
                className="flex items-center gap-2 text-[#1e3a70] font-medium text-sm hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
              >
                詳しく見る
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </button>
            </div>
          </div>

          {/* 整理収納 */}
          <div className="group bg-white rounded-2xl overflow-hidden hover:translate-y-[-4px] transition-all duration-300 border border-stone-100">
            <div className="relative overflow-hidden" style={{ height: '240px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=clean%20organized%20japanese%20home%20interior%20neat%20storage%20system%20minimalist%20living%20room%20bright%20airy%20space%20tidily%20arranged%20shelves%20cabinets%20modern%20lifestyle%20photography%20warm%20natural%20light&width=800&height=480&seq=biz2&orientation=landscape"
                alt="整理収納アドバイザー事業"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-4 left-4">
                <span className="bg-orange-500 text-white text-xs font-medium px-3 py-1.5 rounded-full">
                  整理収納アドバイザー事業
                </span>
              </div>
            </div>
            <div className="p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-orange-50 rounded-full flex items-center justify-center">
                  <i className="ri-home-heart-line text-orange-500 text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-stone-800">整理収納<br />アドバイザーサービス</h3>
              </div>
              <p className="text-stone-500 text-sm leading-relaxed mb-6">
                看護師の視点から安全で快適な暮らしを実現。子育て世帯・介護世帯向けに、家族みんなが使いやすい整理収納プランの提案と実施をサポートします。
              </p>
              <div className="flex flex-wrap gap-2 mb-6">
                {['子育て世帯', '介護世帯', '訪問サポート', 'オンライン相談'].map((tag) => (
                  <span key={tag} className="text-xs bg-orange-50 text-orange-600 border border-orange-200 px-3 py-1 rounded-full">
                    {tag}
                  </span>
                ))}
              </div>
              <button
                onClick={() => scrollToSection('organizing')}
                className="flex items-center gap-2 text-orange-500 font-medium text-sm hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
              >
                詳しく見る
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
